import { MenuInterface } from 'src/app/_core/components/layout-nav/routes';
import { RouteActivityType } from 'src/app/board/activity/activity.constants';

export const activityGeneralsSettingsRoutes: MenuInterface[] = [
    {
        code: 'GestionParamRegleTrans_ViewModel',
        route: [
            {
                content: 'activity/settings/interactivity-rules/list',
                focus: 'empty',
            }, 'content'
        ],
    },
    {
        code: 'GestionActivite_ViewModel',
        route: [
            {
                content: 'activity/settings/activities-settings/list',
                focus: 'empty',
            }, 'content'
        ],
    },
    {
        code: 'GestionParamPieceJustifActivite_ViewModel',
        route: [
            {
                content: 'activity/settings/vouchers/list',
                focus: 'empty',
            },
            {
                primaryRoute: 'content',
                queryParams: {
                    activityType: RouteActivityType.General,
                    closeButton: 1
                }
            }
        ],
    },
    {
        code: 'GestionFournisseurs_ViewModel',
        route: [
            {
                content: 'activity/settings/suppliers/list',
                focus: 'empty',
            },
            {
                primaryRoute: 'content',
                queryParams: {
                    activityType: RouteActivityType.General,
                    closeButton: 1
                }
            }
        ],
    },
    {
        code: 'GestionParametrageFraisPort_ViewModel',
        route: [
            {
                content: 'activity/settings/shipping-fee-model/list',
                focus: 'empty',
            }, {
                primaryRoute: 'content',
                queryParams: { closeButton: 1 }
            }
        ],
    },
    {
        code: 'GestionParamChampsFormulaires_ViewModel',
        route: [
            {
                content: 'activity/settings/form-field/list',
                focus: 'empty',
            }, {
                primaryRoute: 'content',
                queryParams: { closeButton: 1 }
            }
        ]
    },
    {
        code: 'GestionParamImportArticle_ViewModel',
        route: [
            {
                content: 'activity/settings/import-article/list',
                focus: 'empty',
            }, 'content'
        ],
    },
    {
        code: 'ActivityGeneralSettingsPaymentMethods',
        route: [
            {
                content: 'activity/settings/payment-method/list',
                focus: 'empty'
            }, 'content'
        ]
    },
    {
        code: 'GestionCompteurPoint_ViewModel',
        route: [
            {
                content: 'activity/settings/points-counter/list',
                focus: 'empty'
            }, {
                primaryRoute: 'content',
                queryParams: { closeButton: 1 }
            }
        ]
    },
    {
        code: 'Gestion_Param_Permanence',
        route: [
            {
                content: 'activity/settings/permanence/list',
                focus: 'empty'
            }, {
                primaryRoute: 'content',
                queryParams: { closeButton: 1 }
            }
        ]
    },
    {
        code: 'GestionParametrageLettreCheque_ViewModel',
        route: [
            {
                content: 'activity/settings/cheque-letter/list',
                focus: 'empty'
            }, {
                primaryRoute: 'content',
                queryParams: { closeButton: 1 }
            }
        ]
    }
];
